var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 160,
    viewBox: "0 0 246 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4228 14.11C78.3128 14.75 78.6728 15.37 79.2728 15.59C79.1728 15.81 79.0828 16.03 78.9828 16.25C78.1428 15.84 77.7128 14.89 77.9528 14C78.1128 14.04 78.2728 14.07 78.4228 14.11Z",
    fill: "#D7B4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.281 12.9085L178.496 13.0605L178.8 14.6313L179.586 14.4792L179.281 12.9085Z",
    fill: "#D7B4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.993 16.5011L146.676 17.7661L148.142 20.452L150.459 19.187L148.993 16.5011Z",
    fill: "#D7B4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.123 38.1198C53.243 35.1798 56.3631 28.4098 54.6631 22.0498C57.1131 21.5598 59.563 21.0598 62.013 20.5698C63.533 30.2298 58.033 39.5198 49.013 42.7498C48.383 41.1998 47.753 39.6598 47.123 38.1198Z",
    fill: "#351F67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.207 66.3306L45.9648 66.4707L46.2462 68.9649L47.4883 68.8247L47.207 66.3306Z",
    fill: "#D7B4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78191 32.9484L6.82227 35.6108L12.1566 37.5335L13.1163 34.8711L7.78191 32.9484Z",
    fill: "#351F67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8989 66.9702L0.683594 69.9702L1.6836 73.7086L12.8989 70.7086L11.8989 66.9702Z",
    fill: "#351F67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7832 68.5302C62.8032 65.0902 65.1032 62.7601 67.2932 62.3901C67.1032 63.1101 67.1432 63.7801 67.3332 64.3401C65.7132 65.0001 64.2532 67.4701 65.3332 70.4401C64.3932 70.0201 63.5232 69.3802 62.7832 68.5302Z",
    fill: "#D7B4F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0027 84.8423L53.8555 87.7061L55.3919 90.4676L60.5391 87.6039L59.0027 84.8423Z",
    fill: "#351F67"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.875 22.4168C195.958 23.1764 201.651 19.5713 203.47 13.8978C205.568 14.7218 207.673 15.5533 209.771 16.3773C206.189 24.462 197.469 28.818 189.042 26.8517C189.313 25.3659 189.591 23.8876 189.875 22.4168Z",
    fill: "#351F67"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.423 33.2337C119.629 36.0082 121.738 38.2141 124.419 38.5196C124.24 39.5221 124.06 40.5386 123.881 41.541C119.972 40.6678 117.258 37.1799 117.388 33.2634C118.062 33.2533 118.742 33.2506 119.423 33.2337Z",
    fill: "#D7B4F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.805 3.07513C151.982 3.87326 150.14 6.52797 150.4 9.36223C149.314 9.39081 148.243 9.42023 147.158 9.44881C147.228 5.22426 150.262 1.66895 154.347 0.965915C154.49 1.66843 154.648 2.37178 154.805 3.07513Z",
    fill: "#351F67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.095 53.7554L166.195 53.7256L166.136 61.5354L170.035 61.5652L170.095 53.7554Z",
    fill: "#D7B4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.92 13.0953L136.881 14.2627L137.467 15.2868L139.506 14.1194L138.92 13.0953Z",
    fill: "#351F67"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0205 96.1064L56.5605 96.126L56.5997 103.046L60.0596 103.026L60.0205 96.1064Z",
    fill: "#D7B4F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.978 51.3946L206.5 52.5498L208.82 53.5087L209.297 52.3536L206.978 51.3946Z",
    fill: "#351F67"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.477 82.6142L187.684 93.8828L191.44 94.8138L194.233 83.5453L190.477 82.6142Z",
    fill: "#351F67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.886 50.0107L228.906 55.9009L232.066 55.8902L232.047 50L228.886 50.0107Z",
    fill: "#351F67"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.241 54.5639L237.586 57.6025L243.663 60.9123L245.318 57.8737L239.241 54.5639Z",
    fill: "#D7B4F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.053 34.4385L139.016 36.1011L139.572 36.7829L141.61 35.1203L141.053 34.4385Z",
    fill: "#351F67"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.274 71.537C136.711 69.2217 139.918 69.2606 141.669 70.5531C141.033 70.9054 140.586 71.3963 140.315 71.9046C138.756 71.2042 136.012 71.8512 134.659 74.6336C134.318 73.6787 134.182 72.6224 134.274 71.537Z",
    fill: "#ED1E79"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.279 96.7488L134.482 97.4014L135.68 98.8637L136.477 98.2111L135.279 96.7488Z",
    fill: "#C1272D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5677 24.8392L80.5781 26.147L82.9863 27.9693L83.9759 26.6615L81.5677 24.8392Z",
    fill: "#D7B4F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.997 108.475C135.521 105.708 134.028 103.007 131.494 102.009C131.931 101.071 132.369 100.133 132.806 99.1956C136.401 101.07 138.144 105.182 137.001 108.982C136.337 108.823 135.66 108.649 134.997 108.475Z",
    fill: "#0071BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.853 69.4933C101.92 71.769 102.725 74.3449 104.732 75.6381C104.201 76.3649 103.655 77.0909 103.117 77.8243C100.364 75.6021 99.582 71.7739 101.227 68.7182C101.764 68.9763 102.302 69.2344 102.853 69.4933Z",
    fill: "#C1272D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.684,
    cy: 110,
    r: 50,
    fill: "#D7B4F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6836 112.667L111.35 124.333L139.684 96",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e6730333e553724d84f1fc974adb3602.svg";
export { ForwardRef as ReactComponent };